export default __webpack_public_path__ + "static/media/Themu.b85510cb.png";